// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as zod from "zod";

export const getMasterPassFormSchema = (isUpdate: boolean) => {
  return zod.object({
    merchantId: zod.number().min(1, { message: "Merchant ID must be a positive number" }).nonnegative(),
    restriction: isUpdate
      ? zod.boolean()
      : zod.boolean().refine(value => value === true, {
          message: "Restriction must be true",
        }),
    clientId: zod.string().min(1, { message: "client" }),
    encKey: zod.any().optional(),
    macKey: zod.any().optional(),
    terminalGroupId: zod.string().min(1, { message: "Please provide a terminal group ID" }).nonempty()
  });
};

export type MasterPassAddFormSchemaFormValuesType = zod.infer<
  typeof masterPassAddFormSchema
>;

export const masterPassAddInitialValues: MasterPassAddFormSchemaFormValuesType =
  {
    merchantId: 0,  
    restriction: true, 
    clientId: "", 
    encKey: "", 
    macKey: "", 
    terminalGroupId: "" 
  };
